export const dummyPgPromo = [
    {
        ID: 126202,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/PIP2-course-thumb.png',
        name: 'Pure Impact Program',
        promo_text: 'Discover Jack Nicklaus\' "Y-to-Y" secret that will help you make… PERFECT IMPACT',
        url: 'https://members.performancegolf.com/courses/perfect-impact-program-2/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."
    },
    {
        ID: 119966,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/RS-STP-course-thumb.png',
        name: 'Square-To-Path Sequence (Hank Haney & Rick Smith)',
        promo_text: 'The world\'s first Slice-Fix Driver for amateurs with "Square Face Technology"',
        url: 'https://members.performancegolf.com/courses/square-to-path-sequence-hank-haney-rick-smith/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."
    },
    {
        ID: 104530,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/TSA-course-thumb.png',
        name: 'The StraightAway System',
        promo_text: 'Fix the first move of your swing so you start (and finish) your swing on rails',
        url: 'https://members.performancegolf.com/courses/the-straightaway-system/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 99792,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/EZ3-course-thumb-lowres.jpg',
        name: 'EZ3',
        promo_text: 'Hit perfect approach shots with the first ever 3-wood powered by Easy Strike Tech',
        url: 'https://members.performancegolf.com/courses/ez3/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 98055,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/TLD-course-thumb.png',
        name: 'The Launch Deck',
        promo_text: 'NEVER SLICE AGAIN AND Add Up To 40 Dead-Straight Yards To Your Drives!',
        url: 'https://members.performancegolf.com/courses/the-launch-deck/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 94953,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/TSST-course-thumb.png',
        name: 'The Straight Stick',
        promo_text: 'The first-ever Automatic Swing Trainer that dials in a perfect release',
        url: 'https://members.performancegolf.com/courses/straight-stick-2/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 59731,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/ETT-course-thumb.png',
        name: 'Easy Tempo Technique',
        promo_text: 'Use Sir Nick\'s secret "easy tempo" technique to never collapse under pressure',
        url: 'https://members.performancegolf.com/courses/easy-tempo-technique/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 53287,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/DQ-course-thumb.png',
        name: 'Distance Quadrant',
        promo_text: 'LPGA Distance Secret Leaked that gets older players smashing 250+ yard drives',
        url: 'https://members.performancegolf.com/courses/distance-quadrant/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 39914,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/PPM-course-thumb.png',
        name: 'Power Plane Masterclass',
        promo_text: 'Sir Nick\'s Power Plane Masterclass adds 20-30 yards of brutally accurate distance',
        url: 'https://members.performancegolf.com/courses/power-plane-masterclass/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 39339,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/OSSF-course-thumb.png',
        name: 'One Shot Slice Fix',
        promo_text: 'Hank\'s 5-Minute Counter-Slice Sequence Eliminates Your Slice in 1 Shot',
        url: 'https://members.performancegolf.com/courses/one-shot-slice-fix/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 32778,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/Hot-Stick-Putting-Course-Thumb.png',
        name: 'Hot Stick Putting',
        promo_text: 'Learn how to cure the yips, eliminate 3-putts, and make less than 30 putts a round',
        url: 'https://members.performancegolf.com/courses/hot-stick-putting/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 56602,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/PJS-course-thumb.png',
        name: 'Power Joint Secret',
        promo_text: 'This 8-Minute "Swing Cheat" Unlocks 30-50 Yards More Distance',
        url: 'https://members.performancegolf.com/courses/power-joint-secret/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 13957,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/fwm-course-thumb.png',
        name: 'Finesse Wedge Mastery',
        promo_text: '#1 short-game coach in the world reveals how to shave 10 strokes off your round',
        url: 'https://members.performancegolf.com/courses/finesse-wedge-mastery/',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."

    },
    {
        ID: 124,
        image: 'https://members.performancegolf.com/wp-content/uploads/2025/04/pg-coaches-2.png',
        name: 'Champions Pass',
        promo_text: 'Start Your Free 7 Day Trial and Access All of Our Best Selling Courses from the World\'s Top Coaches for Over 90% Off!',
        url: 'https://email.performancegolfzone.net/15HcaC',
        course_desc:"Hall of fame coach who’s fixed over 200,000 slices, engineers the world’s first Slice Fix Driver with 7 features that square the face for you."
    }
];
